<script>
    import { onMount } from "svelte";
    import MyPageination from "./mypageination.svelte";

    // 列表数据
    let page_num = 1;
    let per_page = 10;
    let total_count = 0;
    let total_page = Math.ceil(total_count / per_page);
    let list_url = "/dbapi/userbylevel";
    let count_url = "/dbapi/usercountbylevel?level=1";
    let add_url = "/dbapi/userinfo";
    let del_url = "/dbapi/userdelete";
    let udatas = [];

    // 对话框数据
    let dlg_title = "";
    let dlg_mode = 0; // 0 添加模式，1 修改模式
    let dlg_id = 0;
    let dlg_nickname = "";
    let dlg_phonenumber = "";
    let dlg_cnname = "";
    let dlg_passwd = "";
    let dlg_level = "1";
    let dlg_remark = "";
    let dlg_isactive = true;

    // 加载事件函数
    onMount(() => {
        getUserCount();
        readUserList();
    });
    // 切换页面
    function switchPage(topage) {
        page_num = topage;
        readUserList();
    }
    // 取用户总数
    function getUserCount() {
        jQuery.ajax({
            type: "get",
            url: count_url,
            success: function (response) {
                if (response.code == 200) {
                    total_count = response.result;
                    total_page = Math.ceil(total_count / per_page);
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 读取用户列表
    function readUserList() {
        let tmp_url =
            list_url + "?level=1&page=" + page_num + "&count=" + per_page;
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        udatas = response.result;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 重置对话框信息
    function resetDialogData() {
        dlg_mode = 0;
        dlg_id = 0;
        dlg_nickname = "";
        dlg_phonenumber = "";
        dlg_cnname = "";
        dlg_passwd = "";
        dlg_level = "1";
        dlg_remark = "";
        dlg_isactive = true;
    }
    // 弹出添加用户对话框
    function newUser() {
        dlg_title = "新增用户";
        resetDialogData();
        jQuery("#user-modal").modal("show");
        return;
    }
    // 加载用户信息
    function LoadUserInfo(nickname) {
        let tmp_url = add_url + "?nickname=" + nickname;
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    let udata = response.result;
                    dlg_id = udata["id"];
                    dlg_nickname = udata["nickname"];
                    dlg_phonenumber = udata["phonenumber"];
                    dlg_cnname = udata["cnname"];
                    dlg_level = udata["level"].toString();
                    dlg_remark = udata["remark"];
                    dlg_isactive = udata["isactive"];
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 弹出编辑用户对话框
    function editUser(nickname) {
        dlg_title = "修改用户信息";
        dlg_mode = 1;
        // 加载数据
        LoadUserInfo(nickname);
        jQuery("#user-modal").modal("show");
        return;
    }
    // 提交用户信息数据
    function submitData() {
        // 保存操作
        let tmpLevel = parseInt(dlg_level);
        let udata = {
            id: dlg_id,
            nickname: dlg_nickname,
            cnname: dlg_cnname,
            passwd: dlg_passwd,
            level: tmpLevel,
            phonenumber: dlg_phonenumber,
            remark: dlg_remark,
            isactive: dlg_isactive,
        };
        jQuery.ajax({
            type: "post",
            url: add_url,
            data: JSON.stringify(udata),
            success: function (response) {
                if (response.code == 200) {
                    // 关闭对话框
                    jQuery("#user-modal").modal("hide");
                    resetDialogData();
                    // 更新列表
                    getUserCount();
                    readUserList();
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 删除用户
    function deleteUser(nickname) {
        if (confirm("删除用户" + nickname + "，是否继续？")) {
            // 删除操作
            let dtarget = { target: nickname };
            jQuery.ajax({
                type: "post",
                url: del_url,
                data: JSON.stringify(dtarget),
                success: function (response) {
                    if (response.code == 200) {
                        // 更新列表
                        getUserCount();
                        readUserList();
                    }
                },
                error: function (err) {
                    console.log(err);
                },
            });
        }
    }
    function resetPwd(nickname) {
        if (confirm("重置用户" + nickname + "的密码，是否继续？")) {
            toastr.options = {
                positionClass: "toast-top-center",
            };
            let reset_url = "/dbapi/resetpass";
            let dtarget = { target: nickname };
            jQuery.ajax({
                type: "post",
                url: reset_url,
                data: JSON.stringify(dtarget),
                success: function (response) {
                    if (response.code == 200) {
                        toastr.info("密码重置成功,密码改为:用户代码加'@321'");
                    } else {
                        toastr.info("密码重置失败:" + response.result);
                    }
                },
                error: function (err) {
                    toastr.info("密码重置出错:" + err);
                },
            });
        }
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>用户管理</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">所有用户</h3>
                            <div class="card-tools">
                                <button
                                    type="submit"
                                    class="btn btn-default"
                                    on:click={newUser}
                                >
                                    <i class="bi bi-journal-plus" /> 添加
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- data list-->
                            <div class="row">
                                <table class="table table-bordered table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th width="15%">用户代码</th>
                                            <th width="20%">用户名称</th>
                                            <th width="25%">电话号码</th>
                                            <th width="15%">用户类型</th>
                                            <th width="25%">操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each udatas as udata}
                                            <tr>
                                                <td>{udata.nickname}</td>
                                                <td>{udata.cnname}</td>
                                                <td>{udata.phonenumber}</td>
                                                <td
                                                    >{udata.level === 0
                                                        ? "微信用户"
                                                        : "运营用户"}</td
                                                >
                                                <td>
                                                    <span class="record_op_normal" title="修改">
                                                        <i
                                                            class="bi bi-journal-text"
                                                            on:click={() => editUser(udata.nickname)}
                                                            on:keyup={() => {}} role="button" tabindex="0"
                                                        />
                                                    </span>
                                                    <span class="record_op_warn" title="删除">
                                                        <i
                                                            class="bi bi-journal-x"
                                                            on:click={() => deleteUser(udata.nickname)}
                                                            on:keyup={() => {}} role="button" tabindex="0"
                                                        />
                                                    </span>
                                                    <span class="record_op_warn" title="重置密码">
                                                        <i
                                                            class="bi bi-arrow-clockwise"
                                                            on:click={() => resetPwd(udata.nickname)}
                                                            on:keyup={() => {}} role="button" tabindex="0"
                                                        />
                                                    </span>
                                                </td>
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                            <!-- / data list -->
                            <MyPageination
                                current_page={page_num}
                                page_count={total_page}
                                switch_page_func={switchPage}
                            />
                        </div>
                    </div>
                    <!--/ end of card -->
                </div>
            </div>
        </div>
    </section>
</div>
<!-- /Content Wrapper. -->
<!-- user modal dialog -->
<div class="modal fade" id="user-modal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{dlg_title}</h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="form-lrpadding">
                    <input type="hidden" bind:value={dlg_id} />
                    <div class="form-group row">
                        <label
                            for="inputNickname"
                            class="col-sm-2 col-form-label">用户代码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputNickname"
                                readonly={dlg_mode == 1}
                                bind:value={dlg_nickname}
                                placeholder="不允许为空"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputCNname" class="col-sm-2 col-form-label"
                            >用户名称</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputCNname"
                                bind:value={dlg_cnname}
                                placeholder="不允许为空"
                            />
                        </div>
                    </div>
                    {#if dlg_mode === 0}
                        <div class="form-group row">
                            <label
                                for="inputPasswd"
                                class="col-sm-2 col-form-label">登录密码</label
                            >
                            <div class="col-sm-10">
                                <input
                                    type="password"
                                    class="form-control"
                                    id="inputPasswd"
                                    bind:value={dlg_passwd}
                                    placeholder=""
                                />
                            </div>
                        </div>
                    {/if}
                    <div class="form-group row">
                        <label
                            for="inputPhoneNumber"
                            class="col-sm-2 col-form-label">手机号码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputPhoneNumber"
                                bind:value={dlg_phonenumber}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputLevel" class="col-sm-2 col-form-label"
                            >用户类型</label
                        >
                        <div class="col-sm-10">
                            <select
                                class="form-control"
                                id="inputLevel"
                                bind:value={dlg_level}
                            >
                                <option value="0">微信用户</option>
                                <option value="1">运营用户</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputRemark" class="col-sm-2 col-form-label"
                            >备注说明
                        </label>
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                id="inputRemark"
                                bind:value={dlg_remark}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="offset-sm-2 col-sm-10">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="inputIsActive"
                                    bind:checked={dlg_isactive}
                                />
                                <label
                                    class="form-check-label"
                                    for="inputIsActive">是否启用</label
                                >
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal">关闭</button
                >
                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={submitData}>保存</button
                >
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<style>
    .record_op_normal {
        font-size: 18px;
        padding-left: 8px;
        padding-right: 8px;
        color: darkblue;
        cursor: pointer;
    }
    .record_op_warn {
        font-size: 18px;
        padding-left: 8px;
        padding-right: 8px;
        color: red;
        cursor: pointer;
    }
    .form-lrpadding {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
